import styled from '@emotion/styled'

import { Color } from '../../constants'
import { Circle } from '../Circle'
import { Icon } from '../Icon'

const IconContent = styled.div({
  flexShrink: 0,
  marginLeft: 8,
})

export type SelectedIconProps = {
  selected: boolean
}

export const SelectedIcon = (props: SelectedIconProps) => {
  return (
    <IconContent>
      {props.selected && (
        <Circle backgroundColor={Color.LIGHTER_GREEN} size={16}>
          <Icon color={Color.GREEN} name="CheckIcon" size="sm" />
        </Circle>
      )}
    </IconContent>
  )
}
